module.exports = __webpack_public_path__ + "static/img/zhineng_logo.0824c926.png";